import React, { useEffect } from "react";
import { useSelector } from 'react-redux';
import { useOnUpdate } from 'js/customHooks'
import InfoTooltip from 'components/controls/InfoTooltip';
import { useTranslation } from 'react-i18next';

export default function ChartsTab(props) {
  const {active, setActive} = props
  const depths = useSelector((state) => state.depths);
  const dataset = useSelector((state) => state.dataset);

  const { t } = useTranslation();

  useEffect(() => { 
    console.log('render ChartsTab')
  });

  useOnUpdate(() => { 
    if ("-" in depths || dataset == 'sst-insitu' || dataset == 'sss-insitu')
      setActive("map")
  }, [dataset]);

  function getClass(){
    if (dataset == 'sst-insitu' || dataset == 'sss-insitu')
      return "tabDisabled"
    if (active == "NoData" || (depths && "-" in depths))
      return "tabDisabled"
    if (active=="charts")
      return "tabActive"
    return ""
  }

  if (dataset == 'sst-insitu')
    return 

  return (
    <div className={"tab " + getClass()} id="chartsTab" onClick={()=> setActive("charts")} title={t('tabs.charts.tooltip')} >
      TIME SERIES  
    <InfoTooltip title={t('tabs.charts.info.title')} body={t('tabs.charts.info.body')} />
    </div>
  )
}